import { useEffect, useRef, useState } from "react";
import logoFull from "@/assets/logo-full.png";
import jacobPhoto from "@/assets/testimonial-jacob-new.png";
import bccAds from "@/assets/bcc-ads-manager.png.asset.json";
import bccOrganique from "@/assets/bcc-organique.png.asset.json";
import AccompagnementFormModal from "@/components/AccompagnementFormModal";

/* Page autonome /resultats — design system dédié (dark premium, accent menthe) */

const C = {
  bg: "#080A09",
  surface: "#111614",
  surface2: "#161C19",
  text: "#FFFFFF",
  text2: "#A7B0AB",
  muted: "#6B746F",
  mint: "#08E4A7",
  mintDim: "rgba(8,228,167,0.18)",
  hair: "rgba(255,255,255,0.08)",
};

const css = `
.r8 { background:${C.bg}; color:${C.text}; font-family:'Inter',sans-serif; -webkit-font-smoothing:antialiased; min-height:100vh; }
.r8 *, .r8 *::before, .r8 *::after { box-sizing:border-box; }
.r8-wrap { max-width:1120px; margin:0 auto; padding:0 24px; }
.r8-wrap-wide { max-width:1200px; margin:0 auto; padding:0 24px; }
.r8-sec { padding:64px 0; }
.r8-it { font-family:'Playfair Display',serif; font-style:italic; font-weight:400; }
.r8-h1 { font-size:36px; font-weight:500; letter-spacing:-0.03em; line-height:1.05; margin:0; }
.r8-h2 { font-size:32px; font-weight:500; letter-spacing:-0.02em; line-height:1.1; margin:0; }
.r8-body { font-size:16px; line-height:1.55; color:${C.text2}; }
.r8-muted { font-size:13px; color:${C.muted}; line-height:1.55; }
.r8-num { font-size:40px; font-weight:600; color:${C.mint}; letter-spacing:-0.02em; line-height:1; }
.r8-lab { font-size:13px; font-weight:500; text-transform:uppercase; letter-spacing:0.08em; color:${C.muted}; margin-top:8px; display:block; }
.r8-pill { display:inline-flex; align-items:center; gap:8px; color:${C.muted}; font-size:12px; text-transform:uppercase; letter-spacing:0.16em; padding:0; }
.r8-dot { width:6px; height:6px; border-radius:999px; background:${C.mint}; display:inline-block; }
.r8-btn { display:inline-flex; align-items:center; justify-content:center; min-height:44px; border-radius:999px; font-size:15px; font-weight:600; padding:14px 22px; cursor:pointer; text-decoration:none; transition:transform .18s ease, filter .18s ease, border-color .18s ease; border:1px solid transparent; }
.r8-btn-p { background:${C.mint}; color:${C.bg}; }
.r8-btn-p:hover { transform:translateY(-1px); filter:brightness(1.08); }
.r8-btn-s { background:transparent; color:${C.text}; border-color:rgba(255,255,255,0.16); }
.r8-btn-s:hover { border-color:${C.mint}; transform:translateY(-1px); }
.r8-card { background:${C.surface}; border:1px solid rgba(8,228,167,0.16); border-radius:16px; transition:border-color .2s ease; }
.r8-card:hover { border-color:rgba(8,228,167,0.4); }
.r8-nav { position:sticky; top:0; z-index:40; background:rgba(8,10,9,0.88); backdrop-filter:blur(10px); border-bottom:1px solid ${C.hair}; }
.r8-navrow { display:flex; align-items:center; justify-content:space-between; gap:16px; height:76px; }
.r8-mark { text-decoration:none; color:${C.text}; line-height:1; display:flex; align-items:center; }
.r8-mark img { height:38px; width:auto; display:block; object-fit:contain; }
.r8-hero-metric { background:${C.surface2}; border:1px solid rgba(8,228,167,0.22); border-radius:14px; padding:20px; }
.r8-hero-n { font-size:44px; font-weight:600; color:${C.mint}; letter-spacing:-0.03em; line-height:1; }
.r8-hero-l { display:block; margin-top:10px; font-size:14px; line-height:1.45; color:#C9D2CD; }
.r8-soon { display:inline-flex; align-items:center; gap:8px; border:1px dashed rgba(255,255,255,0.18); color:${C.muted}; font-size:12px; border-radius:999px; padding:6px 12px; }
.r8-navlinks { display:none; gap:26px; align-items:center; }
.r8-navlink { color:${C.text2}; font-size:14px; text-decoration:none; display:inline-flex; align-items:center; gap:7px; }
.r8-navlink:hover { color:${C.text}; }
.r8-navlink.cur { color:${C.text}; }
.r8-navcta { display:none; gap:10px; }
.r8-burger { display:inline-flex; align-items:center; justify-content:center; width:44px; height:44px; border-radius:999px; border:1px solid rgba(255,255,255,0.16); background:transparent; color:${C.text}; cursor:pointer; }
.r8-drawer { background:${C.bg}; border-bottom:1px solid ${C.hair}; padding:16px 24px 28px; display:flex; flex-direction:column; gap:16px; }
.r8-band { border-top:1px solid ${C.hair}; border-bottom:1px solid ${C.hair}; }
.r8-band-grid { display:grid; grid-template-columns:1fr; }
.r8-band-cell { padding:32px 8px; text-align:center; border-top:1px solid ${C.hair}; }
.r8-band-cell:first-child { border-top:none; }
.r8-fade { opacity:0; transform:translateY(12px); transition:opacity .6s ease, transform .6s ease; }
.r8-fade.in { opacity:1; transform:none; }
.r8-grid3 { display:grid; grid-template-columns:1fr; gap:20px; }
.r8-proofgrid { display:grid; grid-template-columns:1fr; gap:20px; }
.r8-frame { background:${C.surface2}; border:1px solid ${C.hair}; border-radius:12px; padding:12px; position:relative; overflow:hidden; }
.r8-frame-top { display:flex; align-items:center; gap:8px; margin-bottom:10px; }
.r8-redact { height:12px; border-radius:4px; background:rgba(255,255,255,0.14); filter:blur(2.5px); }
.r8-row { display:flex; align-items:center; justify-content:space-between; gap:10px; padding:9px 0; border-top:1px solid ${C.hair}; font-size:12px; color:${C.text2}; }
.r8-chip { border:1px solid ${C.mintDim}; color:${C.mint}; font-size:11px; border-radius:999px; padding:3px 9px; white-space:nowrap; }
.r8-chip.m { border-color:${C.hair}; color:${C.muted}; }
.r8-slot { border:1px dashed rgba(8,228,167,0.45); border-radius:12px; padding:34px 16px; text-align:center; color:${C.mint}; font-size:13px; letter-spacing:0.04em; background:rgba(8,228,167,0.03); }
.r8-badge { position:absolute; left:12px; bottom:12px; font-size:11px; color:${C.muted}; background:rgba(8,10,9,0.8); border:1px solid ${C.hair}; border-radius:999px; padding:4px 10px; }
.r8-fpill { min-height:44px; display:inline-flex; align-items:center; padding:10px 16px; border-radius:999px; font-size:13px; cursor:pointer; background:transparent; color:${C.text2}; border:1px solid rgba(255,255,255,0.16); }
.r8-fpill[data-on="true"] { background:${C.mint}; color:${C.bg}; border-color:${C.mint}; font-weight:600; }
.r8-inset { background:${C.surface2}; border-top:1px solid ${C.hair}; border-bottom:1px solid ${C.hair}; }
.r8-input { width:100%; background:${C.surface2}; border:1px solid ${C.hair}; border-radius:12px; padding:13px 14px; color:${C.text}; font-size:15px; font-family:inherit; min-height:44px; }
.r8-input:focus { outline:none; border-color:${C.mint}; }
.r8-input::placeholder { color:${C.muted}; }
.r8-toast { position:fixed; left:50%; bottom:28px; transform:translateX(-50%); z-index:60; background:${C.surface}; border:1px solid ${C.mint}; color:${C.mint}; border-radius:999px; padding:12px 20px; font-size:14px; }
.r8-lb { position:fixed; inset:0; z-index:70; background:rgba(0,0,0,0.8); display:flex; flex-direction:column; align-items:center; justify-content:center; padding:24px; gap:14px; }
.r8-two { display:grid; grid-template-columns:1fr; gap:32px; }
.r8-metrics { background:${C.surface2}; border:1px solid ${C.hair}; border-radius:12px; overflow:hidden; }
.r8-metric { padding:14px 16px; border-top:1px solid ${C.hair}; display:flex; align-items:baseline; gap:12px; }
.r8-metric:first-child { border-top:none; }
.r8-metric-n { font-size:24px; font-weight:600; color:${C.mint}; letter-spacing:-0.01em; line-height:1.1; flex:0 0 auto; }
.r8-metric-l { font-size:14px; font-weight:400; line-height:1.4; color:#C9D2CD; }
.r8-hm { background:radial-gradient(120% 60% at 50% 0%, rgba(8,228,167,0.09), transparent 70%); border-top:1px solid ${C.hair}; }
.r8-bignum { font-family:'Playfair Display',serif; font-weight:400; font-size:52px; line-height:1; letter-spacing:-0.02em; color:${C.mint}; }
.r8-kpi4 { display:grid; grid-template-columns:1fr 1fr; gap:1px; background:${C.hair}; border:1px solid ${C.hair}; border-radius:16px; overflow:hidden; }
.r8-kpi { background:${C.surface}; padding:28px 22px; }
.r8-kpi-n { font-size:36px; font-weight:600; color:${C.mint}; letter-spacing:-0.02em; line-height:1.05; }
.r8-kpi-l { font-size:14px; color:#C9D2CD; margin-top:10px; line-height:1.45; display:block; }
.r8-hk { display:grid; grid-template-columns:1fr 1fr; gap:1px; background:${C.hair}; border:1px solid ${C.hair}; border-radius:18px; overflow:hidden; }
.r8-hk-c { background:${C.surface}; padding:30px 22px; text-align:center; }
.r8-hk-c.hl { background:rgba(8,228,167,0.08); }
.r8-hk-n { font-family:'Playfair Display',serif; font-weight:400; font-size:40px; line-height:1; letter-spacing:-0.02em; color:${C.mint}; }
.r8-hk-l { display:block; margin-top:12px; font-size:12px; letter-spacing:0.1em; text-transform:uppercase; color:#C9D2CD; line-height:1.5; }
.r8-build { display:grid; grid-template-columns:1fr; gap:14px; }
.r8-step { background:${C.surface}; border:1px solid ${C.hair}; border-radius:16px; padding:20px; }
.r8-step-n { font-size:12px; font-weight:600; letter-spacing:0.12em; color:${C.mint}; }
.r8-step-t { font-size:14px; font-weight:600; text-transform:uppercase; letter-spacing:0.08em; margin:10px 0 8px; }
.r8-step-d { font-size:14px; color:${C.text2}; line-height:1.55; margin:0; }
.r8-ledger { border:1px solid ${C.hair}; border-radius:16px; overflow:hidden; background:${C.surface}; }
.r8-led { display:flex; align-items:baseline; justify-content:space-between; gap:16px; padding:16px 20px; border-top:1px solid ${C.hair}; font-size:15px; color:${C.text2}; }
.r8-led:first-child { border-top:none; }
.r8-led b { color:${C.text}; font-weight:600; font-size:20px; white-space:nowrap; }
.r8-led.tot { background:rgba(8,228,167,0.07); color:${C.text}; padding:24px 20px; }
.r8-led.tot b { color:${C.mint}; font-size:32px; }
.r8-tl { display:grid; grid-template-columns:1fr; gap:14px; }
.r8-tlc { border-top:2px solid ${C.mint}; padding-top:16px; }
.r8-footer { background:#050706; border-top:1px solid ${C.hair}; }
@media (min-width:768px) {
  .r8-two { grid-template-columns:1.1fr .9fr; gap:48px; align-items:center; }
  .r8-grid3 { grid-template-columns:repeat(3,1fr); }
  .r8-proofgrid { grid-template-columns:repeat(2,1fr); }
  .r8-band-grid { grid-template-columns:repeat(3,1fr); }
  .r8-band-cell { border-top:none; border-left:1px solid ${C.hair}; padding:44px 24px; }
  .r8-band-cell:first-child { border-left:none; }
  .r8-build { grid-template-columns:repeat(2,1fr); }
  .r8-tl { grid-template-columns:repeat(2,1fr); gap:24px; }
  .r8-kpi4 { grid-template-columns:repeat(4,1fr); }
  .r8-hk { grid-template-columns:repeat(4,1fr); }
  .r8-bignum { font-size:64px; }
}
@media (min-width:1024px) {
  .r8-wrap, .r8-wrap-wide { padding:0 48px; }
  .r8-sec { padding:96px 0; }
  .r8-h1 { font-size:64px; }
  .r8-h2 { font-size:40px; }
  .r8-body { font-size:18px; }
  .r8-num { font-size:48px; }
  .r8-navlinks, .r8-navcta { display:flex; }
  .r8-burger { display:none; }
  .r8-proofgrid { grid-template-columns:repeat(3,1fr); }
  .r8-build { grid-template-columns:repeat(3,1fr); }
  .r8-tl { grid-template-columns:repeat(4,1fr); }
  .r8-hk-n { font-size:52px; }
  .r8-kpi-n { font-size:40px; }
}
@media (prefers-reduced-motion:reduce) {
  .r8-fade { opacity:1; transform:none; transition:none; }
  .r8-btn:hover { transform:none; }
}
`;

const Reveal = ({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={`r8-fade${seen ? " in" : ""}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

const Resultats = () => {
  const [menu, setMenu] = useState(false);
  const [toast, setToast] = useState(false);
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    document.title = "Résultats | Agence 8020 — Preuves, pas des vues";
    const m = document.querySelector('meta[name="description"]');
    const prev = m?.getAttribute("content") ?? "";
    m?.setAttribute(
      "content",
      "Les résultats réels des systèmes de leads bâtis par Agence 8020 à Montréal. Preuves anonymisées, industrie et région seulement. Nombre de partenaires limité."
    );
    return () => m?.setAttribute("content", prev);
  }, []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(false), 3200);
    return () => clearTimeout(t);
  }, [toast]);


  const navLinks = [
    { label: "Accueil", href: "/", cur: false },
    { label: "Services", href: "/services", cur: false },
    { label: "Résultats", href: "/resultats", cur: true },
    { label: "Approche", href: "/accompagnement", cur: false },
  ];

  return (
    <div className="r8">
      <style>{css}</style>

      <AccompagnementFormModal open={formOpen} onOpenChange={setFormOpen} />

      {/* TOP BAR */}
      <header className="r8-nav">
        <div className="r8-wrap-wide">
          <div className="r8-navrow">
            <a href="/" className="r8-mark" aria-label="Agence 8020">
              <img src={logoFull} alt="Agence 8020" />
            </a>
            <nav className="r8-navlinks">
              {navLinks.map((l) => (
                <a key={l.label} href={l.href} className={`r8-navlink${l.cur ? " cur" : ""}`} aria-current={l.cur ? "page" : undefined}>
                  {l.cur && <span className="r8-dot" />}
                  {l.label}
                </a>
              ))}
            </nav>
            <div className="r8-navcta">
              <button type="button" className="r8-btn r8-btn-p" onClick={() => setFormOpen(true)}>
                Nous parler de votre entreprise
              </button>
            </div>
            <button className="r8-burger" aria-label="Menu" onClick={() => setMenu((v) => !v)}>
              <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
                <path d="M0 1h18M0 7h18M0 13h18" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </button>
          </div>
        </div>
        {menu && (
          <div className="r8-drawer">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setMenu(false)} className={`r8-navlink${l.cur ? " cur" : ""}`} style={{ fontSize: 16, minHeight: 44 }}>
                {l.cur && <span className="r8-dot" />}
                {l.label}
              </a>
            ))}
            <button
              type="button"
              className="r8-btn r8-btn-p"
              onClick={() => {
                setMenu(false);
                setFormOpen(true);
              }}
            >
              Nous parler de votre entreprise
            </button>
          </div>
        )}
      </header>

      <main>
        {/* HERO */}
        <section className="r8-sec" style={{ position: "relative", overflow: "hidden" }}>
          <div
            aria-hidden
            style={{
              position: "absolute",
              top: -260,
              left: "50%",
              transform: "translateX(-50%)",
              width: 900,
              height: 560,
              background: "radial-gradient(closest-side, rgba(8,228,167,0.10), transparent)",
              pointerEvents: "none",
            }}
          />
          <div className="r8-wrap" style={{ position: "relative", textAlign: "center" }}>
            <Reveal>
              <span className="r8-pill">
                <span className="r8-dot" />
                Preuves. Pas des vues.
              </span>
            </Reveal>
            <Reveal delay={60}>
              <h1 className="r8-h1" style={{ maxWidth: 860, margin: "24px auto 0" }}>
                Les systèmes qu’on bâtit remplissent des <span className="r8-it" style={{ color: C.mint }}>agendas</span>. Voici la preuve.
              </h1>
            </Reveal>
            <Reveal delay={120}>
              <p className="r8-body" style={{ maxWidth: 700, margin: "22px auto 0" }}>
                Des chiffres d’affaires, des leads, des rendez-vous. Noms d’entreprises masqués. Chiffres recoupés avec les ventes du partenaire — pas avec le pixel tout seul.
              </p>
            </Reveal>
            <Reveal delay={180}>
              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 30 }}>
                <a href="#preuves" className="r8-btn r8-btn-p">
                  Voir les preuves
                </a>
                <button type="button" className="r8-btn r8-btn-s" onClick={() => setFormOpen(true)}>
                  Nous parler de votre entreprise
                </button>
              </div>
              <p className="r8-muted" style={{ maxWidth: 560, margin: "18px auto 0" }}>
                On publie seulement ce qui est vrai au moment où vous lisez ça. Si un chiffre n’est plus bon, on le retire.
              </p>
            </Reveal>
          </div>
        </section>

        {/* BANDEAU 3 CHIFFRES */}
        <section className="r8-band">
          <div className="r8-wrap-wide">
            <div className="r8-band-grid">
              {[
                { n: "10 000+", l: "leads générés pour nos partenaires" },
                { n: "10 M$", l: "en revenus créés côté partenaires" },
                { n: "Limité", l: "nombre de partenaires limité. Pas une file d’attente." },
              ].map((s, i) => (
                <div className="r8-band-cell" key={s.n}>
                  <Reveal delay={i * 70}>
                    <div className="r8-num">{s.n}</div>
                    <span className="r8-lab">{s.l}</span>
                  </Reveal>
                </div>
              ))}
            </div>
            <p className="r8-muted" style={{ textAlign: "center", padding: "22px 0 26px", maxWidth: 720, margin: "0 auto" }}>
              Cumulatif partenaires 8020. Recoupé CRM client. Pas des vues, pas un ROI moyen sorti d’un chapeau.
            </p>
          </div>
        </section>

        {/* NOTE DE MÉTHODE */}
        <section className="r8-sec">
          <div className="r8-wrap">
            <div style={{ maxWidth: 640, margin: "0 auto" }}>
              <Reveal>
                <h2 className="r8-h2">
                  Comment <span className="r8-it">lire</span> cette page
                </h2>
                <p className="r8-body" style={{ marginTop: 18 }}>
                  Chaque carte = une industrie, une région, une fenêtre de temps. Le nom de l’entreprise est masqué parce que la plupart de nos partenaires n’ont pas demandé à devenir une pub. Le chiffre, lui, reste.
                </p>
              </Reveal>
              <div className="r8-grid3" style={{ marginTop: 36 }}>
                {[
                  "Ads Manager — 7-day click seulement",
                  "Recoupé avec le CRM / les rdvs du client",
                  "Identité masquée. Résultat visible.",
                ].map((t, i) => (
                  <Reveal key={t} delay={i * 70}>
                    <div>
                      <span style={{ color: C.mint, fontSize: 13, fontWeight: 600, letterSpacing: "0.08em" }}>0{i + 1}</span>
                      <p style={{ margin: "8px 0 0", fontSize: 15, lineHeight: 1.5, color: C.text2 }}>{t}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CE QU'ON MESURE — SANS CARTES, TOUTES INDUSTRIES */}
        <section className="r8-sec" id="preuves">
          <div className="r8-wrap">
            <Reveal>
              <span className="r8-pill">La logique</span>
              <h2 className="r8-h2" style={{ marginTop: 20, maxWidth: 760 }}>
                Peu importe l’industrie, on mesure les mêmes <span className="r8-it" style={{ color: C.mint }}>choses</span>.
              </h2>
              <p className="r8-body" style={{ marginTop: 14, maxWidth: 680 }}>
                On ne vend pas une niche. On bâtit un système d’acquisition et on le juge sur quatre chiffres — les mêmes pour tout le monde.
              </p>
            </Reveal>

            <Reveal delay={70}>
              <div className="r8-ledger" style={{ marginTop: 34 }}>
                {[
                  ["Coût d’acquisition", "Ce que ça coûte réellement pour obtenir une demande qualifiée."],
                  ["Rendez-vous tenus", "Pas les clics. Les vraies rencontres qui entrent à l’agenda."],
                  ["Taux de closing", "Ce que l’offre convertit une fois le prospect devant vous."],
                  ["Revenus générés", "Le seul chiffre qui décide si le système fonctionne."],
                ].map(([t, d]) => (
                  <div className="r8-led" key={t} style={{ display: "block", padding: "22px 24px" }}>
                    <div style={{ fontSize: 18, fontWeight: 600, color: C.mint, letterSpacing: "-0.01em" }}>{t}</div>
                    <p style={{ margin: "8px 0 0", fontSize: 15, lineHeight: 1.6, color: C.text2 }}>{d}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            <p className="r8-muted" style={{ marginTop: 28, maxWidth: 720 }}>
              On ne fabrique pas un chiffre pour faire joli. Les preuves ci-dessous viennent de dossiers réels, avec les noms masqués quand le partenaire le demande.
            </p>
          </div>
        </section>



        {/* BUREAU CANADIEN DU CRÉDIT */}
        <section className="r8-sec" id="bureau-canadien-credit" style={{ paddingTop: 0 }}>
          <div className="r8-wrap">
            <Reveal>
              <span className="r8-lab" style={{ marginTop: 0 }}>Partenaire · services financiers</span>
              <h2 className="r8-h2" style={{ marginTop: 14, maxWidth: 820 }}>
                Bureau canadien du crédit : <span className="r8-it" style={{ color: C.mint }}>3,17 $</span> le lead moyen.
              </h2>
            </Reveal>

            <Reveal delay={60}>
              <div className="r8-hk" style={{ marginTop: 34, gridTemplateColumns: "repeat(2, minmax(0,1fr))" }}>
                <div className="r8-hk-c hl">
                  <div className="r8-hk-n">3,17 $</div>
                  <span className="r8-hk-l">coût moyen par lead</span>
                </div>
                <div className="r8-hk-c">
                  <div className="r8-hk-n">100 %</div>
                  <span className="r8-hk-l">des leads viennent du système</span>
                </div>
              </div>
            </Reveal>

            <Reveal delay={75}>
              <div
                style={{
                  marginTop: 28,
                  display: "grid",
                  gap: 20,
                  gridTemplateColumns: "1fr",
                  alignItems: "start",
                }}
              >
                {[
                  { src: bccAds.url, cap: "Gestionnaire de publicités — coût par lead réel" },
                  { src: bccOrganique.url, cap: "Contenu organique — vues et portée par vidéo" },
                ].map((s) => (
                  <figure
                    key={s.cap}
                    style={{
                      margin: 0,
                      alignSelf: "start",
                      background: C.surface,
                      border: `1px solid ${C.hair}`,
                      borderRadius: 16,
                      padding: 12,
                    }}
                  >
                    <img
                      src={s.src}
                      alt={s.cap}
                      loading="lazy"
                      style={{ width: "100%", height: "auto", display: "block", borderRadius: 10 }}
                    />
                    <figcaption style={{ marginTop: 10, fontSize: 12.5, color: C.muted }}>{s.cap}</figcaption>
                  </figure>
                ))}
              </div>
            </Reveal>




            <Reveal delay={90}>
              <div style={{ marginTop: 40 }}>
                <h3 className="r8-h2" style={{ fontSize: 26 }}>Ce qui fait la différence?</h3>
                <div className="r8-ledger" style={{ marginTop: 20 }}>
                  {[
                    ["Créatifs ultra poussés", "Des publicités travaillées jusqu’au détail : accroche, montage, message. C’est ce qui fait chuter le coût par lead."],
                    ["Stratégie pensée pour vous", "Pas de gabarit recyclé. Le système est bâti autour de votre offre, votre marché et votre capacité à livrer."],
                  ].map(([t, d]) => (
                    <div className="r8-led" key={t} style={{ display: "block", padding: "22px 24px" }}>
                      <div style={{ fontSize: 18, fontWeight: 600, color: C.mint, letterSpacing: "-0.01em" }}>{t}</div>
                      <p style={{ margin: "8px 0 0", fontSize: 15, lineHeight: 1.6, color: C.text2 }}>{d}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* SÉPARATEUR — NOUVEAU PARTENAIRE */}
        <div className="r8-wrap" style={{ paddingTop: 8, paddingBottom: 8 }}>
          <div style={{ height: 1, background: C.hair }} />
        </div>

        {/* ÉTUDE DE CAS — HORS MARCHÉ QUÉBEC */}
        <section className="r8-hm" id="hors-marche" style={{ padding: "72px 0" }}>
          <div className="r8-wrap-wide">
            <Reveal>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", color: C.muted }}>
                  Autre partenaire · autre industrie
                </div>
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 24,
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                    color: C.text,
                  }}
                >
                  Hors Marché Québec — immobilier
                </div>
                <span className="r8-pill" style={{ display: "inline-block", marginTop: 10 }}>
                  Étude de cas · lancement événement + cohorte
                </span>

                <h2 className="r8-h2" style={{ maxWidth: 820, margin: "22px auto 0" }}>
                  <span className="r8-it" style={{ color: C.mint }}>118 770 $</span> générés en 14 jours de campagne publicitaire.
                </h2>
                <p className="r8-body" style={{ maxWidth: 680, margin: "18px auto 0" }}>
                  Hors Marché Québec · Jean-Nicolas Lacasse — un lancement complet : stratégie, créatifs, courriels, publicité, pipeline.
                </p>
              </div>
            </Reveal>

            {/* Résumé chiffré — lecture d'un coup d'œil */}
            <Reveal delay={60}>
              <div className="r8-hk" style={{ marginTop: 40 }}>
                {[
                  ["118 770 $", "revenus générés", true],
                  ["6 464 $", "investis en publicité", false],
                  ["18,4×", "retour sur le budget pub", true],
                  ["14 jours", "de campagne", false],
                ].map(([n, l, hl]) => (
                  <div className={`r8-hk-c${hl ? " hl" : ""}`} key={l as string}>
                    <div className="r8-hk-n">{n}</div>
                    <span className="r8-hk-l">{l}</span>
                  </div>
                ))}
              </div>
            </Reveal>


            {/* Point de départ */}
            <Reveal delay={70}>
              <div className="r8-build" style={{ marginTop: 42 }}>
                {[
                  ["Le client", "15 ans de terrain, 200+ transactions, un pivot de marque à lancer."],
                  ["Le défi", "Lancer un événement payant de 4 soirs en plein été, puis vendre une offre à 7 000 $ derrière."],
                  ["Le délai", "3 semaines entre l’appel stratégique et le premier soir. Créatifs tournés en 1 semaine."],
                  ["La crainte", "Le client s’attendait à perdre de l’argent sur la publicité pour remplir la salle."],
                ].map(([t, d]) => (
                  <div className="r8-step" key={t}>
                    <div className="r8-step-t" style={{ margin: "0 0 8px", color: C.mint }}>{t}</div>
                    <p className="r8-step-d">{d}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            {/* L'événement */}
            <Reveal delay={90}>
              <div style={{ marginTop: 56 }}>
                <span className="r8-lab" style={{ marginTop: 0 }}>L’événement · billets à 57 $ et 127 $</span>
                <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>L’événement s’est payé tout seul.</h3>
                <div className="r8-kpi4" style={{ marginTop: 22 }}>
                  {[
                    ["158", "inscriptions en 14 jours"],
                    ["11 270 $", "de billets vendus"],
                    ["6 464 $", "investis en publicité"],
                    ["+4 808 $", "de profit avant même le pitch"],
                  ].map(([n, l]) => (
                    <div className="r8-kpi" key={l}>
                      <div className="r8-kpi-n">{n}</div>
                      <span className="r8-kpi-l">{l}</span>
                    </div>
                  ))}
                </div>
                <p className="r8-muted" style={{ marginTop: 16, maxWidth: 760 }}>
                  Le client s’attendait à un break-even, au mieux. L’acquisition a été rentable avant que l’offre principale soit même présentée.
                </p>
              </div>
            </Reveal>

            {/* La cohorte */}
            <Reveal delay={90}>
              <div className="r8-two" style={{ marginTop: 56 }}>
                <div>
                  <span className="r8-lab" style={{ marginTop: 0 }}>La cohorte · offre haut de gamme</span>
                  <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>
                    Le vrai moteur : l’offre <span className="r8-it">derrière</span>.
                  </h3>
                  <p className="r8-body" style={{ marginTop: 16 }}>
                    15 opérateurs fermés à 7 000 $ et 7 500 $, convertis depuis les 158 inscrits : pitch en direct, puis relances courriel + SMS sur 4 jours. Deux plans de paiement offerts.
                  </p>
                </div>
                <div className="r8-card" style={{ padding: 32, textAlign: "center" }}>
                  <div className="r8-bignum">107 500 $</div>
                  <span className="r8-kpi-l" style={{ marginTop: 12 }}>
                    de ventes haut de gamme, sur une audience bâtie en 2 semaines
                  </span>
                </div>
              </div>
            </Reveal>

            {/* Ligne par ligne */}
            <Reveal delay={90}>
              <div style={{ marginTop: 56 }}>
                <span className="r8-lab" style={{ marginTop: 0 }}>Le résultat complet</span>
                <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>Ligne par ligne :</h3>
                <div className="r8-ledger" style={{ marginTop: 22 }}>
                  <div className="r8-led"><span>Billets d’événement (158 × 57-127 $)</span><b>11 270 $</b></div>
                  <div className="r8-led"><span>Ventes de la cohorte (15 opérateurs · 7 000 $ et 7 500 $)</span><b>107 500 $</b></div>
                  <div className="r8-led"><span>Investissement publicitaire total</span><b>− 6 464 $</b></div>
                  <div className="r8-led tot">
                    <span className="r8-lab" style={{ marginTop: 0, color: C.text }}>Revenus générés</span>
                    <b>118 770 $</b>
                  </div>
                </div>
                <p className="r8-muted" style={{ marginTop: 14 }}>18,4× le budget publicitaire.</p>
              </div>
            </Reveal>

            {/* Échéancier */}
            <Reveal delay={90}>
              <div style={{ marginTop: 56 }}>
                <span className="r8-lab" style={{ marginTop: 0 }}>L’échéancier réel</span>
                <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>De l’appel au pitch : 4 semaines.</h3>
                <div className="r8-tl" style={{ marginTop: 26 }}>
                  {[
                    ["Sem. 0", "Appel stratégique", "Positionnement, offre, plan de campagne décidés le jour 1"],
                    ["Sem. 1", "Production", "16 créatifs tournés et montés · pages et séquences écrites"],
                    ["Sem. 2-3", "Campagne", "550 $/jour · 158 inscriptions · optimisation quotidienne"],
                    ["Sem. 4", "Le pitch", "Offre à 7 000 $ présentée en direct · relances sur 4 jours"],
                  ].map(([w, t, d]) => (
                    <div className="r8-tlc" key={w}>
                      <div className="r8-step-n">{w}</div>
                      <div style={{ fontSize: 17, fontWeight: 600, margin: "8px 0 6px" }}>{t}</div>
                      <p className="r8-step-d">{d}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>

            {/* Ce qu'on a bâti */}
            <Reveal delay={90}>
              <div style={{ marginTop: 56 }}>
                <span className="r8-lab" style={{ marginTop: 0 }}>Ce qu’on a bâti</span>
                <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>Pas du contenu. Un système.</h3>
                <div className="r8-build" style={{ marginTop: 24 }}>
                  {[
                    ["01", "Stratégie", "Positionnement du pivot, offre, prix, échéancier de lancement"],
                    ["02", "Créatifs", "16 concepts publicitaires : vidéos fondateur, statiques, scripts"],
                    ["03", "Courriels + SMS", "11 courriels de vente, séquences de relance, textos calibrés"],
                    ["04", "Publicité Meta", "550 $/jour · prospection large + retargeting structuré"],
                    ["05", "Pages + tech", "Landing, page de paiement, diagnostic et migration d’hébergement"],
                    ["06", "Pipeline CRM", "Suivi des inscrits, relances post-pitch, tri des opportunités"],
                  ].map(([n, t, d]) => (
                    <div className="r8-step" key={n}>
                      <div className="r8-step-n">{n}</div>
                      <div className="r8-step-t">{t}</div>
                      <p className="r8-step-d">{d}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>

            {/* Pourquoi ça fonctionne */}
            <Reveal delay={90}>
              <div style={{ marginTop: 56 }}>
                <span className="r8-lab" style={{ marginTop: 0 }}>Pourquoi ça fonctionne</span>
                <h3 className="r8-h2" style={{ fontSize: 26, marginTop: 10 }}>
                  Trois leviers, un seul <span className="r8-it" style={{ color: C.mint }}>moteur</span>.
                </h3>
                <div className="r8-grid3" style={{ marginTop: 24 }}>
                  {[
                    ["1", "Le fondateur devant la caméra", "Pas d’acteurs, pas de stock footage. Le client parle à son marché — la confiance se bâtit avant même le premier soir."],
                    ["2", "Chaque canal pousse le même message", "Pub, courriel, SMS, organique : une seule histoire, calibrée par canal. Le prospect entend la même voix partout."],
                    ["3", "Le front-end finance le back-end", "L’événement payant filtre les curieux et rembourse la pub. La vraie marge se fait sur l’offre principale, à une audience déjà convaincue."],
                  ].map(([n, t, d]) => (
                    <div className="r8-step" key={n}>
                      <div className="r8-step-n">{n}</div>
                      <div className="r8-step-t">{t}</div>
                      <p className="r8-step-d">{d}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        {/* CAS NOMMÉ */}
        <section className="r8-sec">
          <div className="r8-wrap">
            <div className="r8-two">
              <Reveal>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
                    <img
                      src={jacobPhoto}
                      alt="Jacob Saey-Williamson, courtier immobilier"
                      loading="lazy"
                      style={{
                        width: 132,
                        height: 132,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: `1px solid ${C.hair}`,
                        flexShrink: 0,
                      }}
                    />
                    <div>
                      <h2 className="r8-h2" style={{ margin: 0 }}>Jacob Saey-Williamson</h2>
                      <p style={{ margin: "10px 0 0", color: C.muted, fontSize: 17 }}>Courtier immobilier</p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                      gap: 14,
                      marginTop: 28,
                    }}
                  >
                    {[
                      ["750 K$+", "Chiffre d’affaires généré"],
                      ["2", "Adjointes engagées"],
                      ["Entrant", "Les gens écrivent en premier"],
                    ].map(([v, l]) => (
                      <div
                        key={l}
                        style={{
                          background: C.surface2,
                          border: `1px solid ${C.hair}`,
                          borderRadius: 16,
                          padding: "20px 18px",
                        }}
                      >
                        <div style={{ fontSize: 30, fontWeight: 600, color: C.mint, lineHeight: 1.1 }}>{v}</div>
                        <div style={{ marginTop: 8, fontSize: 14, color: C.muted }}>{l}</div>
                      </div>
                    ))}
                  </div>
                  <p className="r8-body" style={{ marginTop: 28, fontSize: 20 }}>
                    750 K$+ de chiffre d’affaires généré. Deux adjointes engagées pour tenir la croissance. Passage d’une présence incohérente à un système qui amène des gens à écrire en premier.
                  </p>
                  <p className="r8-muted" style={{ marginTop: 18 }}>
                    Les dashboards Ads de ce compte ne sont pas affichés.
                  </p>
                </div>
              </Reveal>
              <Reveal delay={90}>
                <blockquote className="r8-card" style={{ margin: 0, padding: 40, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                  <p style={{ margin: 0, fontSize: 28, lineHeight: 1.4 }} className="r8-it">
                    « Maintenant, les gens me contactent directement grâce à ce qu’ils voient sur mes réseaux. »
                  </p>
                  <footer className="r8-muted" style={{ marginTop: 24 }}>— Jacob Saey-Williamson, courtier immobilier</footer>
                </blockquote>
              </Reveal>
            </div>
          </div>
        </section>

        {/* CAS JULIE-ANN — PLANOVA FINANCE */}
        <section className="r8-sec">
          <div className="r8-wrap">
            <Reveal>
              <span className="r8-pill">Sécurité financière · Québec</span>
              <h2 className="r8-h2" style={{ marginTop: 20 }}>
                Julie-Ann — Planova Finance : <em className="r8-it">37 rendez-vous</em> en 10 jours
              </h2>
              <p className="r8-body" style={{ marginTop: 16, maxWidth: 760 }}>
                Cabinet en sécurité financière lancé à son compte. Objectif : pas de visibilité vide, des rendez-vous
                dans l’agenda. Système bâti en quelques jours : segmentation entrepreneurs / particuliers, deux pages
                de conversion, deux vidéos, publicités Meta et suivis automatisés.
              </p>
            </Reveal>

            <Reveal delay={80}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: 16,
                  marginTop: 32,
                }}
              >
                {[
                  { v: "37", l: "rendez-vous bookés" },
                  { v: "10 jours", l: "après le lancement du système" },
                  { v: "2", l: "audiences segmentées (entrepreneurs / particuliers)" },
                  { v: "2", l: "pages de conversion + 2 vidéos dédiées" },
                ].map((k) => (
                  <div
                    key={k.l}
                    className="r8-card"
                    style={{ padding: "24px 22px", background: C.surface2 }}
                  >
                    <div style={{ color: C.mint, fontSize: 34, fontWeight: 600, letterSpacing: "-0.02em" }}>{k.v}</div>
                    <div style={{ color: C.text2, fontSize: 14, marginTop: 8, lineHeight: 1.4 }}>{k.l}</div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="r8-card" style={{ padding: 28, marginTop: 24 }}>
                <p className="r8-muted" style={{ margin: 0, fontSize: 13, letterSpacing: "0.08em", textTransform: "uppercase" }}>
                  Ce qui a fait la différence
                </p>
                <ul style={{ margin: "16px 0 0", padding: 0, listStyle: "none", display: "grid", gap: 12 }}>
                  {[
                    "Base de données existante segmentée pour la première fois, au lieu d’un message unique pour tout le monde.",
                    "Contenu organique remis à niveau avant de pousser la publicité, pour soutenir la crédibilité.",
                    "Publicités bâties sur des concepts originaux, pas juste des variations de hooks.",
                    "Prise de rendez-vous et suivis automatisés : moins d’administratif, plus de temps sur les bons prospects.",
                  ].map((t) => (
                    <li key={t} style={{ display: "flex", gap: 12, color: C.text2, fontSize: 15, lineHeight: 1.55 }}>
                      <span style={{ color: C.mint }}>—</span>
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="/articles/etude-de-cas-conseillere-securite-financiere-leads"
                  style={{ display: "inline-block", marginTop: 22, color: C.mint, fontSize: 15, textDecoration: "none" }}
                >
                  Lire l’étude de cas complète →
                </a>
              </div>
            </Reveal>
          </div>
        </section>

        {/* CE QU'ON NE MONTRE PAS */}
        <section className="r8-inset" style={{ padding: "64px 0" }}>
          <div className="r8-wrap">
            <div className="r8-two">
              <Reveal>
                <h2 className="r8-h2">Ce qu’on ne met pas sur cette page</h2>
              </Reveal>
              <Reveal delay={80}>
                <div>
                  {[
                    "Les millions de vues",
                    "Le décompte de Reels",
                    "Un ROI moyen sorti d’un chapeau",
                    "« 150 clients satisfaits » alors qu’on prend un nombre limité de partenaires",
                  ].map((l) => (
                    <p key={l} style={{ margin: "0 0 12px", color: C.text2, fontSize: 16, lineHeight: 1.55 }}>
                      <span style={{ color: C.mint, marginRight: 8 }}>—</span>
                      {l}
                    </p>
                  ))}
                </div>
              </Reveal>
            </div>
            <Reveal delay={140}>
              <p className="r8-body" style={{ marginTop: 32, color: C.text }}>
                Si vous cherchez une agence qui collectionne les captures de portée organique, ce n’est pas ici.
              </p>
            </Reveal>
          </div>
        </section>

        {/* CONTACT */}
        <section className="r8-sec" id="contact">
          <div className="r8-wrap" style={{ textAlign: "center" }}>
            <Reveal>
              <span className="r8-pill">Partenaires limités</span>
              <h2 className="r8-h2" style={{ maxWidth: 760, margin: "20px auto 0" }}>
                Ton métier n’est pas dans les cartes? <span className="r8-it" style={{ color: C.mint }}>Tant mieux.</span>
              </h2>
              <p className="r8-body" style={{ maxWidth: 620, margin: "18px auto 0" }}>
                On calibre le système sur votre offre, pas sur un template. Si le fit n’y est pas, on vous le dit.
              </p>
              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 28 }}>
                <button type="button" className="r8-btn r8-btn-p" onClick={() => setFormOpen(true)}>
                  Réserver l’appel découverte
                </button>
              </div>
            </Reveal>

            <div className="r8-grid3" style={{ marginTop: 44, textAlign: "left" }}>
              {[
                { t: "Appel découverte", d: "1 h" },
                { t: "Proposition", d: "sous 24 h" },
                { t: "Démarrage", d: "3 à 5 jours" },
              ].map((s, i) => (
                <Reveal key={s.t} delay={i * 70}>
                  <div className="r8-card" style={{ padding: 20 }}>
                    <span style={{ color: C.mint, fontSize: 13, fontWeight: 600, letterSpacing: "0.08em" }}>0{i + 1}</span>
                    <p style={{ margin: "10px 0 4px", fontSize: 16, fontWeight: 500 }}>{s.t}</p>
                    <span className="r8-lab" style={{ marginTop: 0 }}>{s.d}</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal>
              <div style={{ marginTop: 44 }}>
                <button type="button" className="r8-btn r8-btn-p" onClick={() => setFormOpen(true)}>
                  Nous parler de votre entreprise
                </button>
              </div>
            </Reveal>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="r8-footer">
        <div className="r8-wrap" style={{ padding: "36px 24px" }}>
          <div className="r8-grid3" style={{ gap: 18, alignItems: "center" }}>
            <p style={{ margin: 0, fontSize: 14, color: C.text }}>AGENCE 8020 · Montréal</p>
            <p className="r8-muted" style={{ margin: 0, textAlign: "center" }}>On ne vend pas du contenu. On bâtit des systèmes.</p>
            <p className="r8-muted" style={{ margin: 0, textAlign: "right" }}>
              <a href="/politique-confidentialite" style={{ color: C.muted, textDecoration: "none" }}>
                Politique de confidentialité
              </a>{" "}
              ·{" "}
              <a href="mailto:info@agence8020.com" style={{ color: C.muted, textDecoration: "none" }}>
                info@agence8020.com
              </a>
            </p>
          </div>
          <p className="r8-muted" style={{ marginTop: 22, borderTop: `1px solid ${C.hair}`, paddingTop: 18 }}>© 2026 Agence 8020</p>
        </div>
      </footer>

      {toast && <div className="r8-toast">Reçu. On vous revient.</div>}

    </div>
  );
};

export default Resultats;
